import angular from 'angular';
import moment from 'moment';

const module = angular.module('whyline.filters.extraDateAppointment', []);

const filter = () => {
  return (slot) => {
    const showExtraAppointmentText = !slot.isEdit || slot.appointmentDateSelected !== slot.hour;
    const extraAppointmentMark = slot.extraAppointment && showExtraAppointmentText ? '(SOBRETURNO)' : '';
    return `${moment(slot.hour).format('HH:mm')} ${extraAppointmentMark}`;
  }
}

module.exports = module.filter('extraDateAppointment', filter);
